import { render, staticRenderFns } from "./ResetPasswordOverlay.vue?vue&type=template&id=763ecfa4&scoped=true"
import script from "./ResetPasswordOverlay.vue?vue&type=script&lang=js"
export * from "./ResetPasswordOverlay.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordOverlay.vue?vue&type=style&index=0&id=763ecfa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ecfa4",
  null
  
)

export default component.exports